// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout[data-v-3732e674]{width:100%;height:100%;background-color:#fff;overflow-y:scroll;-webkit-overflow-scrolling:touch}", ""]);
// Exports
module.exports = exports;
